import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Sparkles icon for greeting/welcome messages
 */
export const SparklesIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M12 3v4m0 10v4M5.5 5.5l2.83 2.83m5.66 5.66l2.83 2.83M3 12h4m10 0h4M5.5 18.5l2.83-2.83m5.66-5.66l2.83-2.83"></path>
    </Icon>
  );
};

export default SparklesIcon;
